import React, { useRef } from "react";

const targetMapping = {
    Recent: "Recent",
    Prior: "Prior",
};


const CustomDateFilter = ({ activeTarget, handleChange, customDatesToDisplay = {} }) => {
    const navLinksRef = useRef({});
    const { startDate = '', endDate = '' } = customDatesToDisplay || {}

    const handleClick = (event) => {
        event.preventDefault();
        const target = event.currentTarget.getAttribute("data-target");
        handleChange(targetMapping[target]);

        // Update the class names for active and inactive links
        Object.values(navLinksRef.current).forEach((link) => {
            link.classList.remove("active");
        });

        if (navLinksRef.current[target]) {
            navLinksRef.current[target].classList.add("active");
        }
    };

    return (
        <div className="col-md-4">
            <div className="mb-4 w-400">
                <div style={{ border: "none", width: '800px', fontSize: '17px', padding: '4px' }} className="dmqGroup">
                    <button
                        className={`${targetMapping[activeTarget] === "Recent" ? "active" : ""
                            }`}
                        data-target="Recent"
                        ref={(el) => (navLinksRef.current["Recent"] = el)}
                        onClick={handleClick}
                    >

                        {endDate && `Recent Monitoring Data (${endDate})`}
                    </button>
                    {endDate !== startDate && <>&nbsp;&nbsp;
                        <button
                            className={`${targetMapping[activeTarget] === "Prior" ? "active" : ""
                                }`}
                            data-target="Prior"
                            ref={(el) => (navLinksRef.current["Prior"] = el)}
                            onClick={handleClick}
                        >
                            {startDate && `Prior Monitoring Data (${startDate})`}

                        </button> </>}


                </div>
            </div>
        </div>
    );
};

export default CustomDateFilter;
